import React from 'react';
import { ITF_NOTICE_TEXT } from '../constants';

export const itfNotice = (
  <p className="vads-u-margin-top--0">{ITF_NOTICE_TEXT}</p>
);
